export enum EBrandManagementTypes {
    START_LOADER = '[brand_management] start loader',
    STOP_LOADER = '[brand_management] stop loader',

    UPDATE_FEATURE_FLAGS_START = '[brand_management] update feature flags start ',
    UPDATE_FEATURE_FLAGS_SUCCESS = '[brand_management] update feature flags success ',
    UPDATE_FEATURE_FLAGS_FAILED = '[brand_management] update feature flags failed ',
}
